import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
} from "@mui/material";

import { useAuth } from "resources/AuthProvider";
import { useFeedbackStore } from "store/useFeedbackStore";
import { RoleType } from "types/Models";

import styles from "./AppFeedback.module.css";

const AppFeedback = () => {
  const { user } = useAuth();
  const { open, severity, mode, title, message, details, closeFeedback } = useFeedbackStore();

  const isPrivilegedUser =
    user?.role === RoleType.ADMINISTRADOR || user?.role === RoleType.SUPERADMIN;
  const showDetails = severity === "error" && isPrivilegedUser && Boolean(details);

  if (!open) {
    return null;
  }

  if (mode === "snackbar") {
    return (
      <Snackbar
        open={open}
        autoHideDuration={4000}
        onClose={closeFeedback}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        className={styles.snackbar}
      >
        <Alert
          onClose={closeFeedback}
          severity={severity}
          variant="filled"
          className={styles.snackbarAlert}
        >
          {message}
        </Alert>
      </Snackbar>
    );
  }

  return (
    <Dialog open={open} onClose={closeFeedback} classes={{ paper: styles.dialogPaper }}>
      <DialogTitle className={styles.dialogTitle}>
        <div className={styles.dialogTitleRow}>
          {severity === "success" ? (
            <CheckCircleOutlineRoundedIcon className={styles.dialogIconSuccess} />
          ) : (
            <ErrorOutlineRoundedIcon className={styles.dialogIconError} />
          )}

          <div>
            <span className={styles.dialogHeading}>{title}</span>
            <span className={styles.dialogSeverity}>
              {severity === "success" ? "Operação concluída" : "Falha ao processar a solicitação"}
            </span>
          </div>
        </div>
      </DialogTitle>

      <DialogContent className={styles.dialogContent}>
        <div className={styles.dialogMessage}>{message}</div>

        {showDetails && (
          <div className={styles.dialogDetails}>
            <span className={styles.dialogDetailsTitle}>Detalhes técnicos</span>
            <div className={styles.dialogDetailsText}>{details}</div>
          </div>
        )}
      </DialogContent>

      <DialogActions className={styles.dialogActions}>
        <Button variant="contained" onClick={closeFeedback} className={styles.dialogButton}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppFeedback;
